import { BusinessStatusCodeEnum } from '../../shared/enums/business-status-code.enum';
import { HttpMethodEnum } from '../../shared/enums/http-method.enum';

import { LogLevelEnum } from './log-level.enum';

export class LogRequestModel {
  private readonly cause: string;
  private readonly clientDate: Date = new Date();
  private readonly errorId: BusinessStatusCodeEnum;
  private readonly level: LogLevelEnum;
  private readonly message: string;
  private readonly method: HttpMethodEnum;
  private readonly stackTrace: string;
  private readonly url: string;

  public constructor(
    level: LogLevelEnum,
    message: string,
    cause?: string,
    errorId?: BusinessStatusCodeEnum,
    url?: string,
    method?: HttpMethodEnum,
    stackTrace?: string,
  ) {
    this.cause = cause ?? undefined;
    this.errorId = errorId ?? undefined;
    this.level = level;
    this.message = message;
    this.method = method ?? undefined;
    this.stackTrace = stackTrace ?? undefined;
    this.url = url ?? undefined;
  }

  public toString = (): string =>
    `${this.clientDate} | ${LogLevelEnum[this.level]} | ${this.message} | ${this.cause ?? 'N/A'} | ${this.errorId ?? 'N/A'} | ${this.method ?? 'N/A'} | ${this.url ?? 'N/A'} | ${this.stackTrace ?? 'N/A'}`;
}
